export default __webpack_public_path__ + "static/media/solidity.98038f15.png";